import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "panel-no-access text-center py-4",
  role: "status"
}
const _hoisted_2 = { class: "h5 mb-2" }
const _hoisted_3 = { class: "text-muted mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("i", {
      class: "fas fa-lock fa-2x mb-3 text-muted",
      "aria-hidden": "true"
    }, null, -1)),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('panel.noAccess.title')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('panel.noAccess.body')), 1),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-outline-secondary",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("i", {
        class: "fas fa-arrow-left",
        "aria-hidden": "true"
      }, null, -1)),
      _createTextVNode(_toDisplayString(_ctx.$t('panel.noAccess.back')), 1)
    ])
  ]))
}